var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalletLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.5922,
    height: 3.55734,
    transform: "matrix(0.999999 0.0012952 -0.000511322 1 3.20703 25.6001)",
    fill: "#6C727F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57.5922,
    height: 3.55735,
    transform: "matrix(0.999999 0.0012952 -0.000511322 1 3.20117 37.3391)",
    fill: "#9EA3AD"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.22696,
    height: 8.41905,
    transform: "matrix(0.999999 0.0012952 -0.000511322 1 5.8125 29.0422)",
    fill: "#9EA3AD"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.22696,
    height: 8.41905,
    transform: "matrix(0.999999 0.0012952 -0.000511322 1 28.3887 29.071)",
    fill: "#9EA3AD"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.22696,
    height: 8.41905,
    transform: "matrix(0.999999 0.0012952 -0.000511322 1 50.9648 29.1008)",
    fill: "#9EA3AD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalletLarge);
export default __webpack_public_path__ + "static/media/PalletLarge.172d95e974ba9350a92c4ea909f75c88.svg";
export { ForwardRef as ReactComponent };